module.exports = __webpack_public_path__ + "img/pado.cc790447.svg";